import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { DsIconModule } from '@bmw-ds/components';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-check-icon-cell-renderer',
  standalone: true,
  imports: [CommonModule, DsIconModule],
  template: `
    <span class="cell-content">
      <!--<ds-icon icon="checkbox_circle" size="lg" tone="positive"></ds-icon>-->
      <img
        *ngIf="showLabel === 'y'"
        src="/assets/images/ora_y.png"
        class="ora_icon"
      />
      <img
        *ngIf="showLabel === 'n'"
        src="/assets/images/ora_n.png"
        class="ora_icon"
      />
      <img
        *ngIf="showLabel === 's'"
        src="/assets/images/ora_s.png"
        class="ora_icon"
      />
      <span *ngIf="showLabel === ' '" class="label">&nbsp;</span>
    </span>
  `,
  styles: [
    `
      :host {
        display: inline-block;
      }
      .cell-content {
        display: inline-flex;
        align-items: center;
        gap: 6px;
      }
      .label {
        display: inline-block;
      }
      .ora_icon {
        width: 30px;
        height: 30px;
        margin-top: 0.4rem;
      }
    `,
  ],
})
export class CheckIconCellRenderer implements ICellRendererAngularComp {
  public value: any;
  public params!: ICellRendererParams;
  public showIcon: boolean = false;
  public label: string = '';
  public showLabel: string = '';

  agInit(params: ICellRendererParams<any, any, any>): void {
    this.params = params;
    this.value = params.value;
    this.showIcon = this.isAffirmative(this.value);
    this.label = String(params?.value ?? '');
    switch (this.label.toLowerCase()) {
      case 'y':
        this.showLabel = 'y';
        break;
      case 'n':
        this.showLabel = 'n';
        break;
      case 's':
        this.showLabel = 's';
        break;
      default:
        this.showLabel = ' ';
    }
  }

  refresh(params: ICellRendererParams<any, any, any>): boolean {
    this.params = params;
    this.value = params.value;
    this.showIcon = this.isAffirmative(this.value);
    this.label = String(params?.value ?? '');
    switch (this.label.toLowerCase()) {
      case 'y':
        this.showLabel = 'y';
        break;
      case 'n':
        this.showLabel = 'n';
        break;
      case 's':
        this.showLabel = 's';
        break;
      default:
        this.showLabel = ' ';
    }
    return true;
  }

  private isAffirmative(val: any): boolean {
    if (typeof val === 'boolean') {
      return val;
    }
    const s = String(val ?? '')
      .trim()
      .toLowerCase();
    if (!s) return false;
    if (s === 'no' || s === 'n' || s === 'false' || s === '0') return false;
    return (
      s === 'yes' ||
      s === 'y' ||
      s === 'true' ||
      s === '1' ||
      s.includes('avail') ||
      s === 'ok' ||
      s === ' '
    );
  }
}
